/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import './ModalRegister.scss'
import { getApiUrl } from '../../../api/api'
import Notify from '../../../component/Notify/Notify'

const ModalRegister = ({ closeModal }) => {
  const [formData, setFormData] = useState({
    inviteCode: '',
    username: '',
    password: '',
    confirmPassword: '',
    fullName: '',
    phone: '',
    termsAccepted: true
  })
  const [notiMessage, setNotiMessage] = useState('')
  const [type, settype] = useState('')

  const handleInputChange = e => {
    const { name, value, type, checked } = e.target
    let newValue = type === 'checkbox' ? checked : value

    if (name === 'username') {
      newValue = newValue.replace(/\s/g, '')
    }

    setFormData(prev => ({
      ...prev,
      [name]: newValue
    }))
  }
  const handleSubmit = async e => {
    e.preventDefault()

    const phoneRegex = /^0\d{9}$/
    if (!phoneRegex.test(formData.phone)) {
      setNotiMessage('Số điện thoại không hợp lệ')
      settype('warning')
      return
    }

    if (formData.password !== formData.confirmPassword) {
      setNotiMessage('Mật khẩu xác nhận không khớp')
      settype('warning')
      return
    }

    try {
      const response = await fetch(`${getApiUrl('backend')}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: formData.username,
          password: formData.password,
          code: formData.inviteCode,
          phone: formData.phone
        })
      })

      const data = await response.json()

      if (!response.ok) {
        setNotiMessage(data.message || 'Đăng ký thất bại')
        settype('error')
        return
      }

      setNotiMessage('Đăng ký thành công!')
      settype('success')
      console.log('User:', data)
      closeModal()
    } catch (err) {
      console.error('Lỗi khi đăng ký:', err)
      setNotiMessage('Có lỗi xảy ra, vui lòng thử lại sau.')
      settype('error')
    }
  }

  return (
    <>
      {notiMessage && (
        <Notify
          message={notiMessage}
          setcontent={setNotiMessage}
          type={type}
        />
      )}

      <div className='member-login__regPop active' id='regPop2'>
        <div className='left-pic'>
          <img src='/left-pic.png' alt='' />
        </div>
        <div className='reg-wrap'>
          <h3 className='reg-title'>Đăng ký tài khoản</h3>
          <div className='slogan-box'>
            <p>
              Vui lòng lưu ý thành viên không được phép sở hữu hơn một tài
              khoản.
            </p>
          </div>
          <form className='reg-form' onSubmit={handleSubmit} autoComplete='off'>
            <div className='scroll-area'>
              <div
                className='reg_content_input-group form-input1'
                id='regInvite'
              >
                <label className='reg_content_label'>Mã đại lý</label>
                <input
                  className='reg_content_input'
                  type='text'
                  name='inviteCode'
                  maxLength='15'
                  placeholder='Vui lòng nhập mã giới thiệu'
                  value={formData.inviteCode}
                  onChange={handleInputChange}
                />
              </div>

              <div className='reg_content_input-group form-input1'>
                <label className='reg_content_label reg_content_require'>
                  *Tên đăng nhập
                </label>
                <input
                  className='reg_content_input'
                  type='text'
                  name='username'
                  maxLength='16'
                  autoComplete='username'
                  placeholder='Vui lòng nhập tên đăng nhập'
                  value={formData.username}
                  onChange={handleInputChange}
                  onKeyDown={e => {
                    if (e.key === ' ') {
                      e.preventDefault()
                    }
                  }}
                  required
                />
              </div>

              <div className='reg_content_input-group form-input1'>
                <label className='reg_content_label reg_content_require'>
                  *Số điện thoại
                </label>
                <input
                  className='reg_content_input'
                  type='text'
                  name='phone'
                  maxLength='16'
                  autoComplete='phone'
                  placeholder='Vui lòng nhập số điện thoại'
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className='reg_content_input-group form-input1'>
                <label className='reg_content_label reg_content_require'>
                  *Mật khẩu đăng nhập
                </label>
                <input
                  className='reg_content_input'
                  type='password'
                  name='password'
                  maxLength='20'
                  autoComplete='new-password'
                  placeholder='Vui lòng nhập mật khẩu'
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className='reg_content_input-group form-input1'>
                <label className='reg_content_label reg_content_require'>
                  *Xác nhận mật khẩu
                </label>
                <input
                  className='reg_content_input'
                  type='password'
                  name='confirmPassword'
                  maxLength='20'
                  autoComplete='new-password'
                  placeholder='Xác nhận mật khẩu'
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className='adult-only'>
              <label htmlFor='tycbx1'>
                <input
                  className='reg_content_checkbox'
                  type='checkbox'
                  id='tycbx1'
                  name='termsAccepted'
                  checked={formData.termsAccepted}
                  onChange={handleInputChange}
                  required
                />
                <span className='reg_content_custom-checkbox'></span>
              </label>
              <span className='reg_content_tip'>
                Tôi 18 tuổi trở lên, chấp nhận và đồng ý tất cả chính sách, điều
                khoản và điều kiện, luật lệ, “chính sách thành viên”.
              </span>
            </div>

            <div className='btn-box'>
              <button className='form-btn btn-reg' type='submit'>
                <span>HOÀN THÀNH</span>
              </button>
              <a className='form-btn btn-close' href='#'>
                <span>CÀI ĐẶT</span>
              </a>
            </div>
          </form>
          <span className='reg-close' onClick={closeModal}></span>
        </div>
      </div>
    </>
  )
}

export default ModalRegister
